/**
 * Create Project Use Case
 *
 * Creates a new project with the provided data.
 * This use case handles the business logic for project creation,
 * including validation and data transformation.
 */

import type { IProjectsGateway } from "../ports/IProjectsGateway";
import type { CreateProjectDTO, ProjectDTO } from "../dtos/ProjectDTO";

export class CreateProjectUseCase {
  constructor(private readonly projectsGateway: IProjectsGateway) {}

  async execute(data: CreateProjectDTO): Promise<ProjectDTO> {
    // Validate input
    if (!data.name || data.name.trim().length === 0) {
      throw new Error("Project name is required");
    }

    // Trim and normalize input
    const normalizedData: CreateProjectDTO = {
      name: data.name.trim(),
      description: data.description?.trim(),
      researchGoals: data.researchGoals?.trim(),
      interviewGuide: data.interviewGuide?.trim(),
    };

    return this.projectsGateway.createProject(normalizedData);
  }
}
